export const t = { "en": { "breezeDealImport": { "setupPrompt": "Help me import deals into HubSpot." } } };
export const d = [];